import React from 'react';
import { Box, Container, Typography, Paper, Button } from '@mui/material';
import { Block } from '@mui/icons-material';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { roleHome } from '../lib/roleHome';

export const Unauthorized: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();

  // `replace: true` so the in-app entry we leave from this page can't be the
  // /unauthorized page itself — otherwise hitting back from the destination
  // bounces straight back here.
  const goHome = () => navigate(roleHome(user?.role), { replace: true });

  const handleGoBack = () => {
    // location.key === 'default' means this is the very first entry of the
    // router stack (e.g., user landed on a forbidden URL directly via a
    // bookmark). navigate(-1) would be a no-op there — fall back to home.
    if (location.key === 'default') {
      goHome();
      return;
    }
    navigate(-1);
  };

  const handleGoHome = goHome;

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Paper sx={{ p: 4, textAlign: 'center' }}>
          <Block sx={{ fontSize: 80, color: 'error.main', mb: 2 }} />
          <Typography variant="h4" component="h1" fontWeight="bold" gutterBottom>
            Access Denied
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            You don't have permission to access this page.
          </Typography>
          <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
            <Button variant="outlined" onClick={handleGoBack}>
              Go Back
            </Button>
            <Button variant="contained" onClick={handleGoHome}>
              Go to Dashboard
            </Button>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};
